import { useContext } from 'react'
import { usePortalTranslate } from '@/hooks'
import { EditedCopiesContext } from '@/ui/components/portal-preview/preview-contexts'
import {
  usePortalBackgroundImageUrl,
  usePortalBranding,
  usePortalLogoHeight,
  usePortalLogoUrl,
  usePreviewDevice
} from '@/ui/components/portal-preview/use-portal-branding'

export const HorizontalBanner: React.FC = () => {
  const editedCopies = useContext(EditedCopiesContext)
  const { translate } = usePortalTranslate(editedCopies)

  // Via the hooks rather than the stored settings, so an editor's unsaved values preview.
  const logoUrl = usePortalLogoUrl()
  const backgroundUrl = usePortalBackgroundImageUrl()
  const bannerTextColor = usePortalBranding().backgroundTextColor
  const logoHeight = usePortalLogoHeight()
  const isDesktop = usePreviewDevice() === 'desktop'

  return (
    <div
      data-testid="banner"
      className={
        'relative w-full bg-grey-2 bg-cover bg-center bg-no-repeat ' +
        (isDesktop ? 'h-[415px] px-8' : 'h-[255px] rounded-t-[35px] px-6')
      }
      style={{
        backgroundImage: `url(${backgroundUrl})`
      }}
    >
      <div className={isDesktop ? 'absolute bottom-16' : 'absolute bottom-2'}>
        <div style={{ height: isDesktop ? logoHeight : '2rem' }}>
          <img className="h-full max-w-full object-contain" src={logoUrl} />
        </div>
        <div
          className={
            'mt-2 max-w-lg ' +
            (isDesktop
              ? 'text-3xl font-bold leading-9'
              : 'text-[20px] leading-[28px]')
          }
          style={{ color: bannerTextColor }}
          dangerouslySetInnerHTML={{
            __html: translate('landing_title')
          }}
        />
        <p
          className="mt-2 md:mb-4"
          style={{ color: bannerTextColor }}
          dangerouslySetInnerHTML={{
            __html: translate('landing_subtitle')
          }}
        />
      </div>
    </div>
  )
}

export default HorizontalBanner
